/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, answerSelect } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CONTENT CARD : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	contentcard: {
		position: 'relative',
		extend: answerSelect,
		transition: 'filter .2s linear 0s',

		'&:hover': {
			filter: 'brightness(65%)'
			// '& .overlay': {
			// 	opacity: '1',
			// 	zIndex: '8'
			// }
		},
        '& .delete': {
            bottom: pxToEm(12),
            right: pxToEm(6)
        },

		// ..... NUMBER ..... //
		'& .contentnumber': {
			// flex: '0',
			// order: '1',
			background: theme.color.light.light.swatch,
			borderRadius: pxToEm(10), //'100%', // removed because we have 100s of contents that break this width
			minWidth: pxToEm(22),
			height: pxToEm(22),
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			color: theme.color.primary.medium.swatch,
			fontSize: pxToEm(11),
			textAlign: 'center',
			position: 'absolute',
			top: pxToEm(7),
			left: pxToEm(8),
			zIndex: '2'
		},

		// ..... CONTENT VISUAL ..... //
		'& .contentvisual': {
			// flex: '0',
			// order: '2',
			border: replacePXinStringWithEM(`3px solid #1494F4`),
			borderRadius: pxToEm(8),
			display: 'inline-block',
			width: pxToEm(154),
			height: pxToEm(172),
			position: 'relative',
			zIndex: '1',
			outline: 'none',
			userSelect: 'none',
			transition: 'all .2s linear 0s',
			'& .contenttype': {
				pointerEvents: 'none',
				position: 'absolute',
				bottom: pxToEm(3),
				left: pxToEm(3),
				zIndex: '10'
			},
			// '&:hover': {
			// 	'&:after': {
			// 		animationName: 'fadeIn',
			// 		animationDelay: '0s',
			// 		animationDuration: '.2s',
			// 		animationFillMode: 'forwards',	
			// 	}
			// }
		},

		// click events
		'&.clickable-true': {
			'&:hover': {
				cursor: 'pointer'
			}
		},
        '&.clickable-false': {
            pointerEvents: 'none'
        },

		// ..... CONTENT TYPES ..... //
		'&.quiz': {
			'& .contentvisual': { borderColor: theme.color.quiz.medium.swatch }
		},
		'&.poll': {
			'& .contentvisual': { borderColor: theme.color.poll.medium.swatch }
		},
		'&.story': {
			'& .contentvisual': { borderColor: theme.color.story.medium.swatch }
		},

		// ..... SIZES ..... //
		'&.small': {
			'& .contentvisual': {
				height: pxToEm(112),
				width: pxToEm(100),
				'& .contenttype': { fontSize: '50%' }
			}
		},
		'&.medium': {
			'& .contentvisual': {
				width: pxToEm(128),
				height: pxToEm(148),
				'& .contenttype': { fontSize: '80%' }
			}
		},
		'&.large': {
			'& .contentvisual': {
				width: pxToEm(154),
				height: pxToEm(172)
			}
		}
	}
});